import React from 'react';
import { Box, Button, IconButton, Typography } from '@mui/material';
import { Add } from '@mui/icons-material';
import moment from 'moment';

import { useDateRangesInputContext } from './DateRangesInput.context';

export const AddRangeButton = ({ reply }: { reply?: boolean }) => {
  const {
    dateRanges = { default: [] },
    activeDateRange = { mode: 'default', index: undefined },
    setDateRanges,
    setActiveDateRange,
  } = useDateRangesInputContext();

  const onAdd = () => {
    // const newStart = moment(
    //   dateRanges[dateRanges.length - 1]?.end ||
    //   dateRanges[dateRanges.length - 1]?.start ||
    //   new Date()
    // )
    //   .add(1, 'day')
    //   .toDate();

    // let newId =
    //   dateRanges.length === 0
    //     ? 1
    //     : Math.max(...dateRanges.map(item => item.id));

    // if (activeDateRange) {
    //   newId = Math.max(newId, activeDateRange);
    // }

    // newId += 1;

    // setDateRanges([...dateRanges, { id: newId, start: newStart, end: null }]);
    // setActiveDateRange(newId);
    if (reply) {
      let newId =
        dateRanges.suggest?.length === 0
          ? 1
          : Math.max(...(dateRanges.suggest?.map(item => item.id) || []));

      // if (activeDateRange) {
      //   newId = Math.max(newId, activeDateRange?.index || 0);
      // }

      newId += 1;

      setDateRanges({
        ...dateRanges,
        suggest: [
          ...(dateRanges?.suggest || []),
          { id: newId, start: null, end: null },
        ],
      });
      setActiveDateRange({ mode: 'suggest', index: newId });
    } else {
      let newId =
        dateRanges[activeDateRange.mode]?.length === 0
          ? 1
          : Math.max(
              ...(dateRanges[activeDateRange.mode]?.map(item => item.id) || [])
            );

      if (activeDateRange) {
        newId = Math.max(newId, activeDateRange?.index || 0);
      }

      newId += 1;

      setDateRanges({
        ...dateRanges,
        [activeDateRange.mode]: [
          ...(dateRanges[activeDateRange.mode] || []),
          { id: newId, start: null, end: null },
        ],
      });
      setActiveDateRange({ mode: activeDateRange.mode, index: newId });
    }
  };

  if (activeDateRange.mode === 'default' && dateRanges.default.length === 0) {
    return (
      <Box
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <Button
          startIcon={<Add />}
          sx={{ textTransform: 'unset' }}
          onClick={onAdd}
        >
          Add New Date Range
        </Button>
      </Box>
    );
  }

  return (
    <Box>
      <IconButton size="small" color="secondary" onClick={onAdd}>
        <Add sx={{ fontSize: 'inherit' }} />
      </IconButton>

      <Typography
        variant="caption"
        color="textSecondary"
        sx={{ marginLeft: 0.5 }}
      >
        {reply ? 'Suggest new dates' : 'Add another date range'}
      </Typography>
    </Box>
  );
};
